<template>
	<div class="footer_wrap">
		<img class="footer_img" :src="'./image/footer.png'" alt="">
	</div>
</template>

<script>
	export default {
		name: "index"
	}
</script>

<style lang="less" scoped>
	.footer_wrap {
		width: 100%;
		height: @footerHeight;
		border-top: 20px solid @color;
		background-color: @footerBgColor;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.footer_img {
		width: 480px;
	}





	@media screen and (max-width: 1000px) {
		.footer_wrap {
			height: @footerHeightSM;
			border-top-width: 10px;
		}

		.footer_img {
			width: 350px;
		}
	}





	@media screen and (max-width: 750px) {
		.footer_wrap {
			height: @footerHeightXS;
			border-top-width: 0.1rem;
		}

		.footer_img {
			width: 3.5rem;
		}
	}
</style>
